import { ProgressBar } from '../../common';

export default ({ filename, messages, progress, size, theme }) => (
  <div className="uploading">
    <div className="status">
      {messages.uploaderUploading}
    </div>

    <div className="progress">
      <ProgressBar
        color={theme.mainColor}
        label={(
          <div className="progress-label">
            <div className="progress-label-size">
              {`${filename} (${size})`}
            </div>
            <div className="progress-label-value">
              {`${Math.round(progress * 100)}%`}
            </div>
          </div>
        )}
        progress={progress}
        progressStyle={{borderRadius: 4, height: 8}}
      />
    </div>

    <style jsx>{`
      .status {
        font-size: 1.3rem;
        font-weight: 600;
        text-align: center;
      }
      .progress {
        margin-top: 15px;
        text-align: left;
      }
      .progress-label {
        display: flex;
        font-weight: 400;
      }
      .progress-label-size {
        flex-grow: 1;
        flex-shrink: 1;
      }
      .progress-label-value {
        flex-grow: 0;
        flex-shrink: 0;
      }
    `}</style>
  </div>
);
